import { render, staticRenderFns } from "./DaysTab.vue?vue&type=template&id=5f6e29f8&scoped=true"
import script from "./DaysTab.vue?vue&type=script&lang=ts"
export * from "./DaysTab.vue?vue&type=script&lang=ts"
import style0 from "./DaysTab.vue?vue&type=style&index=0&id=5f6e29f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e29f8",
  null
  
)

export default component.exports